<template>
<b-container class="">
  <b-row align-h="start">
  <h1>Convert LST to ASM</h1>
  </b-row>
  <b-row>
  <h2>Here paste the LST</h2>
  </b-row>
  <b-row>
      <b-form-textarea id="textarea1"
                     v-model="text"
                     placeholder="Enter something, or drag text file here"
                     :rows="3"
                     :max-rows="6">
    </b-form-textarea>
    </b-row>
    <b-row>
    <range-slider
      class="slider"
      min="0"
      max="100"
      step="1"
      v-model="position">
    </range-slider> <p>Cut at position {{position}}</p>
    </b-row>
  <b-row>
  <h2>Here is the cutted ASM</h2>
  </b-row>
    <b-row>
      <div class="sourceout">{{textout}}</div>
    <b-form-textarea id="textarea2"
                     readonly
                     v-model="textout"
                     :rows="10"
                     :max-rows="15">
    </b-form-textarea>
    </b-row>
</b-container>
</template>

<script>
import RangeSlider from 'vue-range-slider'
import 'vue-range-slider/dist/vue-range-slider.css'

var doDrag = function (_this) {
  var holder = document.getElementById('textarea1')

  holder.ondragover = function () {
    this.className = 'form-control';
    return false;
  };
  holder.onmouseleave = function () {
    this.className = 'form-control';
    return false;
  };
  holder.ondrop = function (e) {
    this.className = 'form-control';
    e.preventDefault();

    var file = e.dataTransfer.files[0]
    var reader = new FileReader();
    reader.onload = function (event) {
      _this.text = event.target.result;
    };
    reader.readAsText(file);

    return false;
  };
}

var t2s = function (text, spc = 4) {
  var out = ''
  for (var i = 0; i < text.length; i++) {
    let ch = text[i]
    if (ch !== '\t') {
      out += ch
      continue
    }
    let spaces = spc - ((out.length) % spc)
    while (spaces--) { out += ' ' }
  }
  return out
}

export default {
  name: 'lst2asm',
  components: {RangeSlider},
  data () {
    return {
      text: '',
      position: 24,
     // textout:''
    }
  },
  computed: {
    textout: {
      get () {
        var ln = this.text.split('\n')

        var pos = this.position
        ln = ln.map(function (line) {
          return t2s(line.substr(pos))
        })
        //return "Vole"
        return ln.join('\n')
      },
      set () { return }
    }
  },
  mounted () {
    doDrag(this)
  }
}
</script>

<style>
textarea {font-family: monospace !important;}
</style>
